export default "__VITE_ASSET__89dde76c__"